import { Filter } from "./types";

export const getFilter = (filter: any, filterType: Filter) =>
  ({
    doctors: {
      ids: filter?.doctors?.map((doctor: string) => +doctor) || []
    },
    procedures: {
      ids: filter?.procedures || []
    }
  }[filterType]);

export const getMissingIds = (filterIds: any[], options: any[]): any[] => {
  const optIds = options.map(opt => opt.name || opt._id || opt.id);
  return filterIds.filter(id => !optIds.includes(id));
};
